import { useValidateEmail } from '@/hooks'

import type { Texts } from '../useTexts'

type ValidateEmail = ReturnType<typeof useValidateEmail>

export const createValidateEmail = async (
  texts: Texts,
  email: string,
  validateEmail: ValidateEmail,
) => {
  const invalidEmailError = {
    id: 'invalidEmailError',
    field: 'email',
    message: texts.errors.format,
    priority: 3,
  }

  const requiredEmailError = {
    id: 'emailRequiredError',
    message: texts.errors.email,
    field: 'email' as const,
    priority: 3,
  }

  const requiredError = email.length === 0

  // until email has value we don't want to validate it
  const valid = requiredError ? true : await validateEmail(email)

  return {
    [requiredEmailError.id]: requiredError ? requiredEmailError : undefined,
    [invalidEmailError.id]: !valid ? invalidEmailError : undefined,
  }
}
